import { curry } from 'lib/util'
import chain from 'app/_shared/events/util/chain'
import purge from 'app/_shared/events/util/purge'
import redirect from 'app/_shared/events/redirect'

/**
 * Force Redirect Event Handler
 *
 * nullifies current module's error
 * executes router redirect event handler
 *
 * @type {Gaia.AppModule.EventHandler}
 */
const forceRedirect = async (module, component, event) => chain(
  purge,
  redirect,
)(module, component, event)

export default curry(forceRedirect)
